import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * CcfOpenNewTabIcon used to disply open new tab icon in the custom workspace iframe panel
 * @param props - SvgIconProps
 * @example -- <CcfOpenNewTabIcon />
 */
export function CcfOpenNewTabIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.6 0V1.6H13.28L8.24 6.64L9.36 7.76L14.4 2.72V6.4H16V0H9.6Z" fill="#3F5C69"/>
        <path d="M14.4 12.8C14.4 13.68 13.68 14.4 12.8 14.4H3.2C2.32 14.4 1.6 13.68 1.6 12.8V3.2C1.6 2.32 2.32 1.6 3.2 1.6H8V0H3.2C1.44 0 0 1.44 0 3.2V12.8C0 14.56 1.44 16 3.2 16H12.8C14.56 16 16 14.56 16 12.8V8H14.4V12.8Z" fill="#3F5C69"/>
      </svg>
    </SvgIcon>
  );
}
  
export default CcfOpenNewTabIcon;